export const scannerSetStorageFilter = (storageFilter) => ({
  type: 'SCANNER_SET_STORAGE_FILTER',
  storageFilter: storageFilter,
});